import React, { useState, useEffect } from 'react'
import Loading from '../Commons/Loading/Loading';
import FooterFormulario from '../Commons/FooterFormulario/FooterFormulario'
import { Link } from 'react-router-dom';

import '../Divisiones/DivisionesDetalles.scss'
import { Modal } from 'react-bootstrap'
import ObraThumb from '../Commons/ObraThumb/ObraThumb';
import ObrasRealizadas from '../Commons/ObrasRealizadas/ObrasRealizadas';


const TanqueTK471B = () => {


    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);

    const [imgUrl, setImgUrl] = useState('');
    const [txtDes, setDesc] = useState('');

    const handleClose = () => {
        setShow(false);
    };

    const handleShow = (paramUrl, paramDesc) => {

        setImgUrl(paramUrl)
        setDesc(paramDesc)
        setShow(true)

        console.log(paramUrl, ', ', paramDesc);
    };

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 1000)
    })

    if (loading) { return <Loading /> }

    return (

        <section className='container-fluid p-0 containerBlock' >


            <Modal
                show={show}
                size='lg'
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Construcción Tanque</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <img src={imgUrl} alt="Modal de la imagen amplicada." className='d-block modal__size text-center' loading='lazy' />
                </Modal.Body>

                <Modal.Footer>
                    <small >{txtDes}</small>
                </Modal.Footer>

            </Modal>

            <div className='divisionItem__container animated fast fadeIn'>
                <img src="../images/headers/headers-obras-civiles.jpg"
                    alt="Obras, andamios."
                    loading='lazy'
                    className='divisionItem__container--img'
                />

                <div className='divisionItem__container--textos divisionItem__container--textos-obras' >
                    <h3 className='divisionItem__container--header'>OBRAS</h3>
                    <h1 className='divisionItem__container--title'>Construcción Tanque</h1>
                </div>

            </div>

            <div className='container-fluid obrasItem__detail'>
                <div className='container animated fast fadeIn'>
                    <Link to={'/obras/'}>
                        <small>
                            <i className="fas fa-angle-double-left" style={{ 'paddingBottom': '15px', 'paddingRight': '10px' }} ></i>
                            Volver a Obras
                        </small>
                    </Link>

                    <div className='row'>

                        <div className='col-md-6'>
                            <img
                                src="../images/obras/tanque-tk-471b/tanque-tk-471b-18.jpg"
                                alt="Construcción de Tanque Skimmer 2548 m³"
                                className='d-block w-100 divisionItem__detail--header'
                                loading='lazy'
                            />
                        </div>

                        <div className='col-md-6 divisionItem__detail--block'>
                            <h1 className='divisionItem__detail--title' >Construcción de Tanque Skimmer 2548 m³</h1>
                            <h3 className='divisionItem__detail--subtitle' >Valle Hermoso – Chubut</h3>

                            <p className='divisionItem__detail--text pt-2' >
                                Construcción de tanque tipo Skimmer bajo norma API 650, de capacidad máxima de 2548 m3.<br /><br />
                                Posee un diámetro de 18000 <small>mm</small> y una altura de 10000 <small>mm</small>.<br /><br />
                                Cuenta con dos platos difusores de 2000 mm y 5800 <small>mm</small> de altura respectivamente y techo cónico con estructura de soporte interna.
                            </p>

                        </div>

                    </div>

                    <div className='row obras__box justify-content-center'>
                        <div className='col-6 col-sm-3 col-md-6 col-lg-3 obras__card'>
                            <ObraThumb
                                ObraNum={'1500'}
                                ObraVal={'m2'}
                                ObraItem={''}
                                ObraDet={'Pintura'}
                            />
                        </div>
                        <div className='col-6 col-sm-3 col-md-6 col-lg-3 obras__card'>
                            <ObraThumb
                                ObraNum={'2000'}
                                ObraVal={'m'}
                                ObraItem={'lineales'}
                                ObraDet={'Soldadura'}
                            />
                        </div>
                        <div className='col-6 col-sm-3 col-md-6 col-lg-3 obras__card'>
                            <ObraThumb
                                ObraXL={false}
                                ObraNum={'1500'}
                                ObraVal={'m'}
                                ObraItem={'lineales'}
                                ObraDet={'perfiles'}
                            />
                        </div>
                        <div className='col-6 col-sm-3 col-md-6 col-lg-3 obras__card'>
                            <ObraThumb
                                ObraXL={false}
                                ObraNum={'1500'}
                                ObraVal={'m2'}
                                ObraItem={''}
                                ObraDet={'chapas'}
                            />
                        </div>
                        <div className='col-6 col-sm-3 col-md-6 col-lg-3 obras__card'>
                            <ObraThumb
                                ObraNum={'670'}
                                ObraVal={'m2'}
                                ObraItem={''}
                                ObraDet={'Aislación (chapa trapezoidal)'}
                            />
                        </div>
                        <div className='col-6 col-sm-3 col-md-6 col-lg-3 obras__card'>
                            <ObraThumb
                                ObraXL={false}
                                ObraNum={'566'}
                                ObraVal={'m2'}
                                ObraItem={'(70 kg/m3)'}
                                ObraDet={'Lana mineral'}
                            />
                        </div>
                    </div>

                    <div className='gallery__cont'>

                        <div className='gallery__cont--column'>
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-01.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-01.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-02.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-02.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-03.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-03.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-04.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-04.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-06.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-06.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                        </div>
                        <div className='gallery__cont--column'>
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-07.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-07.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-08.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-08.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-09.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-09.jpg' alt='Tanque de 5.000m3' loading='lazy' />

                        </div>

                        <div className='gallery__cont--column'>
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-11.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-11.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-12.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-12.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-13.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-13.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-14.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-14.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-15.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-15.jpg' alt='Tanque de 5.000m3' loading='lazy' />

                        </div>

                        <div className='gallery__cont--column'>
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-05.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-05.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-16.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-16.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-17.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-17.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-19.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-19.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-10.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-10.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-24.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-24.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                        </div>

                        <div className='gallery__cont--column'>
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-20.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-20.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-21.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-21.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-22.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-22.jpg' alt='Tanque de 5.000m3' loading='lazy' />
                            <img onClick={() => handleShow('../images/obras/tanque-tk-471b/tanque-tk-471b-23.jpg', 'Construcción de Tanque Skimmer 2548 m³')} src='../images/obras/tanque-tk-471b/tanque-tk-471b-23.jpg' alt='Tanque de 5.000m3' loading='lazy' />

                        </div>



                    </div>
                </div>
            </div>
            <div className='otrasObras__container'>
                <ObrasRealizadas cantObras={5} excluir={2} />
            </div>
            <FooterFormulario className='mt-5' />
        </section>
    )
}

export default TanqueTK471B